import React, { useState, useMemo } from 'react';
import { FLEET_FALLBACK_IMAGES } from '../constants/fleet';

/**
 * Image component with error handling and fallback
 */
const FleetImage = ({ 
  src, 
  alt, 
  className = '', 
  fallbackSrc = null,
  vehicleType = null,
  vehicleName = null,
  ...props 
}) => {
  const [hasError, setHasError] = useState(false);
  const [currentSrc, setCurrentSrc] = useState(src || '');

  const computedFallback = useMemo(() => {
    if (fallbackSrc) return fallbackSrc;
    return (
      FLEET_FALLBACK_IMAGES[vehicleName] ||
      FLEET_FALLBACK_IMAGES[vehicleType] ||
      FLEET_FALLBACK_IMAGES['Sedan']
    );
  }, [fallbackSrc, vehicleName, vehicleType]);

  const handleError = () => {
    if (!hasError) {
      setHasError(true);

      setCurrentSrc(computedFallback);
    }
  };

  const handleLoad = () => {
    setHasError(false);
  };
  
  return (
    <img
      src={currentSrc}
      alt={alt}
      className={className}
      onError={handleError}
      onLoad={handleLoad}
      {...props}
    />
  );
};

export default FleetImage;
